import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NgControl, NG_VALUE_ACCESSOR, ValidationErrors, Validator, ValidatorFn, Validators } from '@angular/forms';
import { QuestionnaireService } from '../services/questionnaire.service';

function coerceBooleanPropery(value: any): boolean {
  return value != null && `${value}` !== "false";
}
@Component({
  selector: 'app-animated-input',
  templateUrl: './animated-input.component.html',
  styleUrls: ['./animated-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimatedInputComponent implements OnInit, ControlValueAccessor {
  @Input() maxLength: string | number | null;
  @Input() placeholder: string = '';
  @Input() type: 'text' | 'email' | 'password' | 'tel' = 'text';
  @Input() animatedLabel: boolean = false;
  @Input() hasCurrencyMask: boolean = false;
  @Input() hasTitle: boolean = false;
  @Input() currencyMask: any;
  @Input() attAriaLabel: any;
  @Input() attrId: any = '';
  @Input() isDisabled: boolean = false;
  @Input() controlValue: string = '';
  @Input() minValue: number;
  @Input() hasPercent: boolean = false;
  private _value: any = '';
  private _disabled: boolean = false;
  control: AbstractControl;
  submitted: boolean = false;

  @ViewChild('inp1') inp1: ElementRef;
  @ViewChild('inp2') inp2: ElementRef;
  @ViewChild('inp3') inp3: ElementRef;
  @ViewChild('inp4') inp4: ElementRef;
  @ViewChild('inp5') inp5: ElementRef;
  @ViewChild('inp6') inp6: ElementRef;

  constructor(@Self() @Optional() public ngControl: NgControl,
    private _changeDetector: ChangeDetectorRef, private questionnaireService: QuestionnaireService) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  _controlValueAccessorChangeFn: (value: any) => void = () => { }

  onTouched: () => any = () => { }

  @Input()
  get value() {
    return this._value;
  }

  set value(newValue) {
    if (this._value !== newValue) {
      //Set this before procceeding to ensure no circular loop occurs with selection.
      this._value = newValue;
      this._controlValueAccessorChangeFn(this._value);
    }
  }

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  set disables(value) {
    this._disabled = coerceBooleanPropery(value);
  }

  get errors() {
    const control = this.ngControl && this.ngControl.control

    if (control) {
      this.control = control;
      return control.touched && control.errors;
    }
    return null;
  }

  onChange(event: any) {
    this._controlValueAccessorChangeFn(event);

  }

  ngOnInit() {
    this.errors;
    // if(this.control.touched){
    //   this.control.markAsUntouched();
    //   this.control.updateValueAndValidity();
    // }
    this.questionnaireService.submitted$.subscribe(isSubmitted => {
      if (isSubmitted) {
        this.control.markAsTouched();
        this.submitted = true;
        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }
      }
      else {
        this.submitted = false;
      }
    })
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== null) {
      this.value = value;
      this._changeDetector.markForCheck();

    }
  }

  registerOnChange(fn: any): void {
    this._controlValueAccessorChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
    this._changeDetector.markForCheck();
  }

}



// WEBPACK FOOTER //
// ./src/app/animated-input/animated-input.component.ts